<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-avatar
        color="white"
        :class="['elevation-5 cursor-pointer', className]"
        size="25"
        v-bind="attrs"
        v-on="on"
        @click="$emit('click')"
      >
        <v-icon small>{{ icon }}</v-icon>
      </v-avatar>
    </template>
    <span>
      {{ tooltipText }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    icon: { type: String, default: "" },
    tooltipText: { type: String, default: "" },
    className: { type: String, default: "" },
  },
};
</script>

<style></style>
